<template>
  <svg viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path
      d="M8.54169 3.37503H17.7084M6.04169 2.29053L3.63085 4.45953L2.29169 3.25503M8.54169 9.00003H17.7084M6.04169 7.91553L3.63085 10.0845L2.29169 8.88003M8.54169 14.625H17.7084M6.04169 13.5405L3.63085 15.7095L2.29169 14.505"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      :class="containerClass"
    />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
